import React, { useState, useEffect } from 'react';
import DateSplit from '../widgets/date';
import FileUpladM from '../../../../components/FileUpload/FileUploader';
import benefits from '../data/benefits.json';
import AddressFull from './Autocomplete/AddressFull';
import dictionarystreet from '../data/addresses.json';
import AutocompleteSelect from './Autocomplete/AutocompleteSelect';
import { findKgInfo } from '../activity';
import { getKindergartensList } from '../../../kindergartens/list/actions';

import CustomSelect from './Select';

const Step4 = ({ formData, onChange, errors }) => {
  const [showDocumentFields, setShowDocumentFields] = useState(false);
  const [showTerritoryFields, setShowTerritoryFields] = useState(false);
  const [showSiblingFields, setShowSiblingFields] = useState(false);
  const [showEmployeeFields, setShowEmployeeFields] = useState(false);
  const [findingKg, setFindingKg] = useState([]);

  // Визначаємо, які поля показувати в залежності від обраної пільги
  useEffect(() => {
    const selectedBenefit = benefits.find(b => b._id === formData.benefits.type);
    
    setShowDocumentFields(false);
    setShowTerritoryFields(false);
    setShowSiblingFields(false);
    setShowEmployeeFields(false);

    if (selectedBenefit) {
      const benefitName = selectedBenefit.name.toLowerCase();
      
      if (benefitName.includes('територія обслуговування')) {
        setShowTerritoryFields(true);
      } else if (benefitName.includes('брати та сестри') || benefitName.includes('сестри в одному здо')) {
        setShowSiblingFields(true);
      } else if (benefitName.includes('працівників закладу') || benefitName.includes('працівників здо')) {
        setShowEmployeeFields(true);
      } else {
        setShowDocumentFields(true);
      }
    }
  }, [formData.benefits.type]);

  const handleBenefitChange = (value) => {
    onChange('benefits.type', value);
    // Скидаємо всі поля пільг при зміні типу пільги
    onChange('benefits.documentType', '');
    onChange('benefits.documentNumber', '');
    onChange('benefits.issuedTo', '');
    onChange('benefits.issueDate', '');
    onChange('benefits.files', []);
    onChange('benefits.address', '');
    onChange('benefits.kindergarten', '');
    onChange('benefits.siblingBirthCertificate', '');
    onChange('benefits.siblingName', '');
    onChange('benefits.siblingBirthDate', '');
    onChange('benefits.employeeName', '');
    onChange('benefits.employeeRnokpp', '');
  };


  useEffect(()=>{
    async function api(params) {
      setFindingKg(await getKindergartensList({filters:{ 'id_kg': [formData.benefits.kindergarten] }}));      
    }

    if(formData.benefits.kindergarten) api();

  },[formData.benefits.kindergarten])


  const onChangeFindKg = async (search)=>{
    if(!search) return;

    const newInfo = await findKgInfo(search);

    if(newInfo && newInfo.length > 0) setFindingKg(newInfo);

  }

  const selectOnlyOneKindergarten = (field, id_kg)=>{
    onChange(field, id_kg);
    onChange('selectedSchools', [id_kg])
  } 

  return (
    <div className="form-section">
      <h2 className="form-section-title">Наявність пільг</h2>
      
      <div className="form-row-plain single">
        <div className="form-group">
          <label className="form-label">Вид пільги</label>
          <CustomSelect
            value={formData.benefits.type}
            onChange={handleBenefitChange}
            options={[
              { value: '', label: 'Відсутня' },
              ...benefits.map(b => ({ value: b._id, label: b.name }))
            ]}
            placeholder="Відсутня"
          />
        </div>
      </div>
      
      {/* Поля для звичайних пільг (з документами) */}
      {showDocumentFields && (
        <>
          <div className="form-row-plain two-cols">
            <div className="form-group">
              <label className="form-label">Тип документа</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsDocumentType ? 'is-invalid' : ''}`}
                placeholder="Довідка, посвідчення"
                value={formData.benefits.documentType}
                onChange={(e) => onChange('benefits.documentType', e.target.value)}
              />
              {errors.benefitsDocumentType && <div className="invalid-feedback">{errors.benefitsDocumentType}</div>}
            </div>
            <div className="form-group">
              <label className="form-label">Номер документа</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsDocumentNumber ? 'is-invalid' : ''}`}
                placeholder="Ф-0919190"
                value={formData.benefits.documentNumber}
                onChange={(e) => onChange('benefits.documentNumber', e.target.value)}
              />
              {errors.benefitsDocumentNumber && <div className="invalid-feedback">{errors.benefitsDocumentNumber}</div>}
            </div>
          </div>
          
          <div className="form-row-plain single">
            <div className="form-group">
              <label className="form-label">Кому видано</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsIssuedTo ? 'is-invalid' : ''}`}
                placeholder="Роман Романович Станіславченко"
                value={formData.benefits.issuedTo}
                onChange={(e) => onChange('benefits.issuedTo', e.target.value)}
              />
              {errors.benefitsIssuedTo && <div className="invalid-feedback">{errors.benefitsIssuedTo}</div>}
            </div>
          </div>

          <DateSplit 
            error={errors.benefitsIssueDate} 
            date={formData.benefits.issueDate} 
            setDate={(v) => onChange('benefits.issueDate', v)} 
            yearFrom={1990}  
            yearTo={2025} 
            label="Дата видачі" 
          />

          <FileUpladM 
            label='Завантажте фото чи скан-копію документа*'  
            value={formData.benefits.files} 
            onChange={(files) => onChange('benefits.files', files)} 
            onBlur={(files) => onChange('benefits.files', files)} 
            onFocus={(files) => onChange('benefits.files', files)}
            multiple={true}
            errorVal={errors.benefitsFiles}
          />
        </>
      )}
      
      {/* Поля для пільги "Територія обслуговування" */}
      {showTerritoryFields && (
              <AddressFull dictionary={formData.dictionary}  title='Адреса проживання' value={formData.benefits.address} fieldsPath= 'benefitsaddress' onChange={onChange} error={errors.benefitsaddress} />
      )}
      
      {/* Поля для пільги "Брати та сестри в одному ЗДО" */}
      {showSiblingFields && (
        <>
          <AutocompleteSelect 
            value={formData.benefits.kindergarten} 
            options={findingKg} 
            onSearch={onChangeFindKg} 
            onChange={(value) => onChange('benefits.kindergarten', value) }
            placeholder='Оберіть ЗДО'
            error={errors.benefitsKindergarten}
            label="Заклад дошкільної освіти"
            className="small"
            fieldsValue={["number","name"]}
          />

          
          <div className="form-row-plain single">
            <div className="form-group">
              <label className="form-label">Номер свідоцтва про народження дитини</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsSiblingBirthCertificate ? 'is-invalid' : ''}`}
                placeholder="СР-123456"
                value={formData.benefits.siblingBirthCertificate}
                onChange={(e) => onChange('benefits.siblingBirthCertificate', e.target.value)}
              />
              {errors.benefitsSiblingBirthCertificate && <div className="invalid-feedback">{errors.benefitsSiblingBirthCertificate}</div>}
            </div>
          </div>
          
          <div className="form-row-plain single">
            <div className="form-group">
              <label className="form-label">Ім'я дитини, що вже навчається</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsSiblingName ? 'is-invalid' : ''}`}
                placeholder="Марія Іванівна Петренко"
                value={formData.benefits.siblingName}
                onChange={(e) => onChange('benefits.siblingName', e.target.value)}
              />
              {errors.benefitsSiblingName && <div className="invalid-feedback">{errors.benefitsSiblingName}</div>}
            </div>
          </div>
          
          <DateSplit 
            error={errors.benefitsSiblingBirthDate} 
            date={formData.benefits.siblingBirthDate} 
            setDate={(v) => onChange('benefits.siblingBirthDate', v)} 
            yearFrom={2010}  
            yearTo={2024} 
            label="Дата народження дитини" 
          />
        </>
      )}
      
      {/* Поля для пільги "Діти працівників закладу" */}
      {showEmployeeFields && (
        <>
          <div className="form-row-plain single">
            <div className="form-group">
                        <AutocompleteSelect 
            value={formData.benefits.kindergarten} 
            options={findingKg} onSearch={onChangeFindKg} 
            onChange={(value) => onChange('benefits.kindergarten', value)}
            placeholder='Оберіть ЗДО'
            error={errors.benefitsKindergarten}
            label="Заклад дошкільної освіти"
            className="small"
            fieldsValue={["number","name"]}
          />
              
            </div>
          </div>
          
          <div className="form-row-plain single">
            <div className="form-group">
              <label className="form-label">Ім'я працівника</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsEmployeeName ? 'is-invalid' : ''}`}
                placeholder="Олена Василівна Сидоренко"
                value={formData.benefits.employeeName}
                onChange={(e) => onChange('benefits.employeeName', e.target.value)}
              />
              {errors.benefitsEmployeeName && <div className="invalid-feedback">{errors.benefitsEmployeeName}</div>}
            </div>
          </div>
          
          <div className="form-row-plain single">
            <div className="form-group">
              <label className="form-label">РНОКПП працівника</label>
              <input
                type="text"
                className={`form-control ${errors.benefitsEmployeeRnokpp ? 'is-invalid' : ''}`}
                placeholder="1234567890"
                value={formData.benefits.employeeRnokpp}
                onChange={(e) => onChange('benefits.employeeRnokpp', e.target.value)}
              />
              {errors.benefitsEmployeeRnokpp && <div className="invalid-feedback">{errors.benefitsEmployeeRnokpp}</div>}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Step4;